import cx from "classnames";

import TextButton from "../components/buttons/TextButton";
import DrawerLayout from "../components/stackables/DrawerLayout";
import { useCurrentDrawer } from "../hooks/stackables";

import styles from "../styles/FulfillerInfoDrawer.module.less";

const allFiftyStateLicensure =
  "AL, AK, AZ, AR, CA, CO, CT, DE, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY (all 50 states)";
const vetsourceTexasStatesOfLicensure =
  "AL, AZ, AR, CO, CT, DE, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY (all 50 states except Alaska, California, Massachusetts, Pennsylvania and Michigan)";

type FulfillerInformationProps = {
  name: string;
  address: string;
  phoneNumber: string;
  hoursOfOperation: string;
  pharmacistInCharge: string;
  statesOfLicensure: string;
  controlledSubstanceText?: string;
};

const FulfillerInformation = ({
  name,
  address,
  phoneNumber,
  hoursOfOperation,
  pharmacistInCharge,
  statesOfLicensure,
  controlledSubstanceText,
}: FulfillerInformationProps) => {
  return (
    <div>
      <div className={styles.partnersLead}>{name}</div>
      <div className={styles.partnersDetail}>
        <div>
          <strong>Address</strong>: {address}
        </div>
        <div>
          <strong>Phone Number</strong>:{" "}
          <TextButton href={`tel:${phoneNumber.replace(/\D/g, "")}`}>{phoneNumber}</TextButton>
        </div>
        <div>
          <strong>States of Licensure</strong>: {statesOfLicensure}
        </div>
        <div>
          <strong>Hours of Operation</strong>: {hoursOfOperation}
        </div>
        <div>
          <strong>Pharmacist in Charge</strong>: {pharmacistInCharge}
        </div>
        {controlledSubstanceText && (
          <div>
            <i>{controlledSubstanceText}</i>
          </div>
        )}
      </div>
    </div>
  );
};

const VetsourceFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Vetsource Pharmacy – Oregon Location"
      address="17014 NE Sandy Blvd., Portland, OR 97230"
      phoneNumber="855-683-6050"
      hoursOfOperation="Monday - Friday 6 AM - 6 PM PST, Saturday 7 AM - 1 PM PST"
      pharmacistInCharge="Mark Balyshev, RPh"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="Vetsource Pharmacy – Oregon Location is licensed to dispense controlled substances in all 50 states."
    />
  );
};

const VetsourcePAFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Vetsource Pharmacy – Pennsylvania Location"
      address="711 Gibson Blvd., Suite A-1, Harrisburg, PA 17104"
      phoneNumber="855-683-6050"
      hoursOfOperation="Monday - Friday 8 AM - 5 PM"
      pharmacistInCharge="Matthew Roesch, RPh"
      statesOfLicensure="AL, AK, AZ, AR, CO, CT, DE, FL, GA, HI, ID, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY (all 50 states except California and Illinois)"
      controlledSubstanceText="Vetsource Pharmacy – Pennsylvania Location is licensed to dispense controlled substances in all states except California and Illinois."
    />
  );
};

const VetsourceTXFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Vetsource Pharmacy – Texas Location"
      address="4251 Dale Earnhardt Way, Suite 100, Northlake, TX 76262"
      phoneNumber="855-683-6050"
      hoursOfOperation="Monday - Friday 8 AM - 6 PM"
      pharmacistInCharge="Natalie Patten, RPh"
      statesOfLicensure={vetsourceTexasStatesOfLicensure}
      controlledSubstanceText="Vetsource Pharmacy – Texas Location is licensed to dispense controlled substances in all states except Alaska, California, Massachusetts, Pennsylvania and Michigan"
    />
  );
};

const TruepillNYFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="FuzeRx Brooklyn"
      address="850 3rd Ave STE 404, Brooklyn, NY 11232"
      phoneNumber="518-692-3362"
      hoursOfOperation="24/7"
      pharmacistInCharge="Michelle Meyer, PharmD, RPh"
      statesOfLicensure={allFiftyStateLicensure}
    />
  );
};

const TruepillOHFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="FuzeRx Sharonville"
      address="2718–2722 E. Kemper Road, Sharonville, OH 45241"
      phoneNumber="513-771-0367"
      hoursOfOperation="Monday - Friday 7 AM - 5:30 PM, Saturday 8 AM - 4:30 PM"
      pharmacistInCharge="Christopher Spitzer"
      statesOfLicensure={allFiftyStateLicensure}
    />
  );
};

const TruepullCAFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="FuzeRx Hayward"
      address="3121 Diablo Ave, Hayward, CA 94545"
      phoneNumber="650-353-5495"
      hoursOfOperation="Mon - Sat 8am to 5pm PST"
      statesOfLicensure={allFiftyStateLicensure}
      pharmacistInCharge="Richard Hagan Myers"
    />
  );
};

const MixlabNYFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Mixlab, Inc. – NY Location"
      address="336 W 37th St. Suite 850 New York, NY 10018"
      phoneNumber="888-901-4480"
      hoursOfOperation="Monday - Friday 10 AM - 6:30 PM, Saturday 10 AM - 4 PM"
      pharmacistInCharge="Natalya Groysman"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="Mixlab is licensed to dispense controlled substances in all 50 states through its network of licensed pharmacy locations. Orders are routed to the appropriate facility based on licensure and fulfillment logistics."
    />
  );
};

const MixlabCAFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Mixlab, Inc. – CA Location"
      address="2223 Federal Ave, Los Angeles, CA 90064"
      phoneNumber="888-901-4480"
      hoursOfOperation="Monday - Friday 9 AM - 6 PM, Saturday 8 AM - 4 PM"
      pharmacistInCharge="Vinh Dam"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="Mixlab is licensed to dispense controlled substances in all 50 states through its network of licensed pharmacy locations. Orders are routed to the appropriate facility based on licensure and fulfillment logistics."
    />
  );
};

const MixlabFLFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Mixlab, Inc. – FL Location"
      address="3880 N 28th Terrace, Hollywood, FL 33020"
      phoneNumber="888-901-4480"
      hoursOfOperation="Monday - Friday 9 AM - 6 PM, Saturday 8 AM - 4:30 PM"
      pharmacistInCharge="Stephania Perticone"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="Mixlab is licensed to dispense controlled substances in all 50 states through its network of licensed pharmacy locations. Orders are routed to the appropriate facility based on licensure and fulfillment logistics."
    />
  );
};

const MixlabTXFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Mixlab, Inc. – TX Location"
      address="953 Hilltop Dr. Weatherford, TX 76086"
      phoneNumber="888-901-4480"
      hoursOfOperation="Monday - Friday 8 AM - 5 PM"
      pharmacistInCharge="Taylor Lerena"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="Mixlab is licensed to dispense controlled substances in all 50 states through its network of licensed pharmacy locations. Orders are routed to the appropriate facility based on licensure and fulfillment logistics."
    />
  );
};

const MixlabWIFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Mixlab, Inc. – WI Location"
      address="407 W Silver Spring Dr. Milwaukee, WI 53217"
      phoneNumber="888-901-4480"
      hoursOfOperation="Monday - Friday 10 AM - 6 PM"
      pharmacistInCharge="Valerie Klippel"
      statesOfLicensure="MT, PA, WI"
      controlledSubstanceText="Mixlab is licensed to dispense controlled substances in all 50 states through its network of licensed pharmacy locations. Orders are routed to the appropriate facility based on licensure and fulfillment logistics."
    />
  );
};

const WedgewoodNJFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Wedgewood Pharmacy LLC – NJ Location"
      address="405 Heron Drive, Suite 200, Swedesboro, NJ 08085"
      phoneNumber="800-331-8272"
      hoursOfOperation="M-F 9am – 8pm, Sat 9am – 5pm (EST)"
      pharmacistInCharge="Alison Lynch"
      statesOfLicensure="AL, AK, AZ, AR, CA, CO, CT, DE, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY"
      controlledSubstanceText="Wedgewood Pharmacy LLC and Wedgewood Connect LLC only ship controlled substances to consumers in states where the facility holds a license."
    />
  );
};

const WedgewoodAZFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Wedgewood Pharmacy LLC – AZ Location"
      address="7631 East Indian School Road, Suite 105, Scottsdale, AZ 85251 (Wholesale Suite # 201)"
      phoneNumber="800-331-8272"
      hoursOfOperation="M-F 9am – 6pm, Sat 9am – 3pm (MST)"
      pharmacistInCharge="Christopher Pucillo"
      statesOfLicensure="AL, AK, AZ, AR, CA, CO, CT, DE, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY"
      controlledSubstanceText="Wedgewood Pharmacy LLC and Wedgewood Connect LLC only ship controlled substances to consumers in states where the facility holds a license."
    />
  );
};

const WedgewoodCABakersfieldFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Wedgewood Pharmacy LLC – Bakersfield Location"
      address="5301 Young Street, Bakersfield, CA 93311"
      phoneNumber="661-377-3333"
      hoursOfOperation="M-F 8:15am – 5:15pm (PST)"
      pharmacistInCharge="Samra Wussow"
      statesOfLicensure="AL, AK, AZ, AR, CA, CO, CT, DE, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY"
      controlledSubstanceText="Wedgewood Pharmacy LLC and Wedgewood Connect LLC only ship controlled substances to consumers in states where the facility holds a license."
    />
  );
};

const WedgewoodCASanJoseFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Wedgewood Connect LLC – San Jose Location"
      address="17 Great Oaks Blvd, San Jose, CA 95119"
      phoneNumber=""
      hoursOfOperation="M-F 8am – 5pm (PST)"
      pharmacistInCharge="Paul Yamamoto"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="Wedgewood Pharmacy LLC and Wedgewood Connect LLC only ship controlled substances to consumers in states where the facility holds a license."
    />
  );
};

const GoGoMedsFulfillerDrawer = () => {
  return (
    <FulfillerInformation
      name="Specialty Medical Drugstore, LLC dba GoGoMeds"
      address="525 Alexandria Pike, Suite 100, Southgate, KY 41071"
      phoneNumber="888-795-5826"
      hoursOfOperation="M - F 9am – 7pm ET, Saturday 9am – 1pm"
      pharmacistInCharge="Ricky Vogel, PharmD"
      statesOfLicensure={allFiftyStateLicensure}
      controlledSubstanceText="GoGoMeds is licensed to dispense controlled substances in all 50 states."
    />
  );
};

const GeneralFulfillerDrawer = () => {
  const { close } = useCurrentDrawer();

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Meet our fast and reliable pharmacy partners" onClose={close} />
      <DrawerLayout.Content>
        <p className={styles.body}>
          Our licensed pharmacy partners help ensure your pet receives high-quality medication
          safely and on time. When your veterinary clinic uses Vetcove&apos;s Home Delivery
          Platform, prescription orders are routed to a pharmacy within our national fulfillment
          network.
        </p>
        <p className={styles.body}>
          After you place an order through this online storefront, your veterinarian reviews and
          approves the request (if medically appropriate). Once approved, the order is routed to a
          licensed pharmacy partner for fulfillment. The pharmacy fills and ships the medication
          directly to your doorstep&mdash;ensuring timely delivery with convenience and care.
        </p>
        <div className={cx(styles.body, styles.partnersList)}>
          <div>
            <strong>Pharmacy Partners</strong>: FuzeRx Pharmacy, Vetsource Pharmacy, and Specialty
            Medical Drugstore (d/b/a GoGoMeds)
          </div>
          <div>
            <strong>Compounding Pharmacy Partners</strong>: Wedgewood, Mixlab Pharmacy
          </div>
        </div>
        <p className={styles.smallBody}>
          The pharmacies maintain appropriate licensure under applicable state and federal laws
          based on the services they provide. None of the pharmacies have a contractual relationship
          with a practitioner to provide medical evaluations based on a questionnaire. Each pharmacy
          dispenses only upon receipt of a valid prescription issued for a legitimate medical
          purpose and based on a valid veterinarian-client-patient relationship (VCPR).
        </p>

        <p className={styles.body}>{VetsourceFulfillerDrawer()}</p>
        <p className={styles.body}>{VetsourcePAFulfillerDrawer()}</p>
        <p className={styles.body}>{VetsourceTXFulfillerDrawer()}</p>
        <p className={styles.body}>{TruepillNYFulfillerDrawer()}</p>
        <p className={styles.body}>{TruepullCAFulfillerDrawer()}</p>
        <p className={styles.body}>{TruepillOHFulfillerDrawer()}</p>
        <p className={styles.body}>{MixlabNYFulfillerDrawer()}</p>
        <p className={styles.body}>{MixlabCAFulfillerDrawer()}</p>
        <p className={styles.body}>{MixlabFLFulfillerDrawer()}</p>
        <p className={styles.body}>{MixlabTXFulfillerDrawer()}</p>
        <p className={styles.body}>{MixlabWIFulfillerDrawer()}</p>
        <p className={styles.body}>{WedgewoodNJFulfillerDrawer()}</p>
        <p className={styles.body}>{WedgewoodAZFulfillerDrawer()}</p>
        <p className={styles.body}>{WedgewoodCABakersfieldFulfillerDrawer()}</p>
        <p className={styles.body}>{WedgewoodCASanJoseFulfillerDrawer()}</p>
        <p className={styles.body}>{GoGoMedsFulfillerDrawer()}</p>
      </DrawerLayout.Content>
    </DrawerLayout>
  );
};

const FulfillerInfoDrawer = () => {
  return <GeneralFulfillerDrawer />;
};

export default FulfillerInfoDrawer;
